<template>
  <loading v-model:active="isLoading"
           :can-cancel="false"
           :on-cancel="onCancel"
           :is-full-page="fullPage"/>
  <carousel  v-if="!isLoading" :items-to-show="1" :autoplay="300">
    <slide class="carousel" v-for="(picLink, index)  in picLinks.data" :key="index">
      <img :src="picLink.img_url" width="100%"/>
    </slide>

    <template #addons>
      <navigation />
    </template>
  </carousel>

</template>

<script>
import http from "@/plugins/axios";
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

// Import Swiper styles
import 'swiper/css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import router from "@/router";
export default {
  components: {
    Loading,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  name: 'pic-link',
  data: () =>({
    isLoading: true,
    fullPage: true,
    picLinks :  {
      data: [],
    },
  }),
  methods: {
    getPicLink() {
      http.get("/piclinks/home_app",)
          .then(response => {
            console.log(response)
          }).catch(error => {
      });
      const AuthStr = 'Bearer '.concat(localStorage.getItem("token"));
      http.get("/piclinks/home_app", { headers: { Authorization: AuthStr } })
          .then(response => {
            this.picLinks = response.data;
            this.isLoading=false
          })
          .catch(function (error) {
            if(error.status==401){
              localStorage.removeItem("token")
              // localStorage.setItem("token",null);
              router.push("login");
            }
            // localStorage.setItem("token",this.auth.token);
          });
    },
  },
  mounted() {
    this.getPicLink();
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
}
</script>

<style scoped>
  .carousel{
    border-radius: 35px;
    overflow: hidden;
  }
</style>